/**
 * A hook that returns the current UTC time in the format of 'YYYY-MM-DD HH:mm:ss' base on the given timestamp.
 * For example:
 * if displayTime is 2023-01-09 11:50 on desired UTC offset (Vary from different timezone),
 * the hook returned value will be 2023-01-09 11:50 in UTC+0.
 */

import { useMemo } from 'react';

import dayjs from 'dayjs';

import { DATETIME_SECONDS_FORMAT } from '@aqx-core/common/dayjs';

import { useMarketTime } from './use-market-time';

interface IUseDisplayUTCTimeProps {
  timestamp: number;
  serverTime: boolean;
}

const convertToDisplayUTC = (_time: string) => {
  const utcTime = dayjs(_time, DATETIME_SECONDS_FORMAT).utc().format(DATETIME_SECONDS_FORMAT);
  return utcTime;
};

const useDisplayUTCTime = (props: IUseDisplayUTCTimeProps) => {
  const { timestamp, serverTime } = props;

  const { displayTime } = useMarketTime({
    timestamp,
    serverTime,
    dateOnly: false
  });

  const displayedUTCTime = useMemo(() => {
    return convertToDisplayUTC(displayTime);
  }, [displayTime]);

  return displayedUTCTime;
};

export { convertToDisplayUTC };

export default useDisplayUTCTime;
